import Block01 from '../modules/blocks/block-01';
import Block09 from '../modules/blocks/block-09';
import Block10 from '../modules/blocks/block-10';
import Block12 from '../modules/blocks/block-12';

export default function setBlocksScripts () {
    new Block01('.block_01');
    new Block09('.block_09');
    new Block10('.block_10');
    new Block12('.block_12');
}
